/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import Logo from "../img/logo.png";
import Button from "@mui/material/Button";
import { createTheme, ThemeProvider } from "@mui/material";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import { Link, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import { ToastContainer, toast, Zoom } from "react-toastify";
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
// import jwt_decode from 'jwt-decode'
import "react-toastify/dist/ReactToastify.css";

export default function PageLogin() {
  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#ffffff"),
    backgroundColor: "#FFA500",
    "&:hover": {
      backgroundColor: "#FF8C00",
    },
  }));

  const [emails, setEmails] = useState("");
  const [perid, setPerid] = useState("");
  const [alerts, setAlerts] = useState(false);
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const otpRefs = React.useRef([]);
  const otp = otpDigits.join("");
  // const [confirm, setComfirm] = useState(false)
  // const [user, setUser] = useState()
  const email = emails.split("@")[0];
  const [open, setOpen] = React.useState(false);
  const [valuess, setValuess] = React.useState({
    password: "",
    showPassword: false,
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  // console.log(email)
  // console.log(values.password)

  // var string = '1111111111';
  // var str = string.split('@')[0];
  // console.log(string.match(/[a-z]/i))
  const navigate = useNavigate();
  const login = async () => {
    if (!email) {
      setAlerts(true);
      toast.error("กรุณาใส่ Email");
      return;
    }
    if (!/^\d{6}$/.test(otp)) {
      setAlerts(true);
      toast.error("กรุณาใส่ OTP 6 หลัก");
      return;
    }
    try {
      let result = await fetch(process.env.REACT_APP_API + "/login", {
        method: "POST",
        body: JSON.stringify({ email, pass: otp }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      result = await result.json();
      if (Array.isArray(result) && result[0]?.token) {
        localStorage.setItem("user", JSON.stringify(result));
        localStorage.setItem("token", JSON.stringify(result[0].token));
        navigate("/PageSelectSchools");
        return;
      }
      setAlerts(true);
      toast.error(
        result?.msg ||
          "Email หรือ OTP ไม่ถูกต้อง หรือถูกระงับการใช้งาน หรือรออนุมัติ กรุณาติดต่อ admin"
      );
    } catch (error) {
      setAlerts(true);
      toast.error("ไม่สามารถเชื่อมต่อระบบได้ กรุณาลองใหม่");
    }
  };

  const loginforeign = async () => {
    const pass = valuess.password;
    if (email === "") {
      setAlerts(true);
      toast.error("กรุณาใส่Emailให้เรียบร้อย!!!");
    } else if (pass === "") {
      setAlerts(true);
      toast.error("กรุณาใส่Passwordให้เรียบร้อย!!!");
    } else if (perid === "") {
      setAlerts(true);
      toast.error("กรุณาใส่รหัสประจำตัวข้าราชการ 10 หลักให้เรียบร้อย!!!");
    } else {
      let results = await fetch(`${process.env.REACT_APP_API}/loginforeign`, {
        method: "POST",
        body: JSON.stringify({ email, pass, perid }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      results = await results.json();

      // const Approv = jwt_decode(results.tokens)
      //  const Approv = jwt_decode(results.token)
      //  console.log(results);
      //  console.log(results.tokens);
      //  localStorage.setItem("user",JSON.stringify(Approv.User))
      //  console.log(results.tokens);
      if (results.status === "ok") {
        // const Approv = jwt_decode(results.tokens)
        // console.log("App: " + JSON.stringify(Approv))
        localStorage.setItem("user", JSON.stringify(results.User));
        localStorage.setItem("token", JSON.stringify(results.tokens));
        toast.success("เข้าสู่ระบบเรียบร้อย!!!");
        navigate("/PageSelectSchools", {
          state: { StausSelect: true },
        });
        //  localStorage.setItem("user",JSON.stringify(Approv.User))
        //  localStorage.setItem("user",JSON.stringify(Approv.User))
      } else {
        setAlerts(true);
        toast.error(
          "Email ไม่ถูกต้อง หรือถูกระงับการใช้งาน หรือรออนุมัติ กรุณาติดต่อ admin!!!"
        );
      }
    }
  };

  const focusOtpBox = (index) => {
    const el = otpRefs.current[index];
    if (el) el.focus();
  };

  const applyOtpValue = (value, startIndex = 0) => {
    const digits = String(value || "").replace(/\D/g, "").slice(0, 6 - startIndex).split("");
    if (!digits.length) return;
    setOtpDigits((prev) => {
      const next = [...prev];
      digits.forEach((digit, i) => {
        next[startIndex + i] = digit;
      });
      return next;
    });
    const nextIndex = Math.min(startIndex + digits.length, 5);
    focusOtpBox(nextIndex);
  };

  const handleOtpChange = (index) => (event) => {
    const raw = String(event.target.value || "");
    if (raw.length > 1) {
      applyOtpValue(raw, index);
      return;
    }
    const digit = raw.replace(/\D/g, "").slice(-1);
    setOtpDigits((prev) => {
      const next = [...prev];
      next[index] = digit;
      return next;
    });
    if (digit && index < 5) focusOtpBox(index + 1);
  };

  const handleOtpKeyDown = (index) => (event) => {
    if (event.key === "Backspace") {
      if (otpDigits[index]) {
        setOtpDigits((prev) => {
          const next = [...prev];
          next[index] = "";
          return next;
        });
      } else if (index > 0) {
        focusOtpBox(index - 1);
        setOtpDigits((prev) => {
          const next = [...prev];
          next[index - 1] = "";
          return next;
        });
      }
      event.preventDefault();
    } else if (event.key === "ArrowLeft" && index > 0) {
      focusOtpBox(index - 1);
      event.preventDefault();
    } else if (event.key === "ArrowRight" && index < 5) {
      focusOtpBox(index + 1);
      event.preventDefault();
    }
  };

  const handleOtpPaste = (index) => (event) => {
    event.preventDefault();
    applyOtpValue(event.clipboardData.getData("text"), index);
  };

  const handleClickShowPasswords = () => {
    setValuess({
      ...valuess,
      showPassword: !valuess.showPassword,
    });
  };

  const handleMouseDownPasswords = (event) => {
    event.preventDefault();
  };

  const handleChanges = (prop) => (event) => {
    setValuess({ ...valuess, [prop]: event.target.value });
  };

  return (
    <React.Fragment>
      {/* <NavbarLogin /> */}
      {/* {confirm ? <ToastContainer draggable={false} transition={Zoom} autoClose={8000} /> : <></> } */}
      {alerts ? (
        <ToastContainer draggable={false} transition={Zoom} autoClose={8000} />
      ) : (
        <></>
      )}
      {/* <div className="containerPageLogin"> */}
      {/* <div className="containerLogin"> */}
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            background: "rgba(23, 15, 95, 0.1)",
            width: { lg: "40vw", md: "60vw", sm: "70vw", xs: "90vw" },
            height: { lg: "90vh", md: "80vh", sm: "100%", xs: "80vh" },
            borderRadius: "10px",
          }}
        >
          <Box>
            <img
              src={Logo}
              alt="logo"
              style={{ width: "150px", height: "120px" }}
            />
          </Box>
          <Box>
            <Typography
              variant="subtitle1"
              gutterBottom
              sx={{
                fontSize: { lg: "20px", md: "16px", sm: "14px", xs: "14px" },
              }}
            >
              ระบบสารสนเทศเพื่อการวัดและประเมินผลการศึกษา
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <Box sx={{ width: "100%", padding: "10px 30px 10px 30px" }}>
              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="outlined">E-mail</InputLabel>
                <OutlinedInput
                  id="outlined"
                  label="E-mail"
                  onChange={(event) => {
                    setEmails(event.target.value);
                  }}
                />
              </FormControl>
            </Box>

            <Box sx={{ width: "100%", padding: "10px 30px 10px 30px" }}>
              <Typography
                sx={{
                  fontWeight: 700,
                  color: "#4a4a4a",
                  fontSize: { lg: "16px", md: "15px", sm: "14px", xs: "13px" },
                  mb: 1.5,
                }}
              >
                รหัส OTP (6 หลัก)
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: { xs: 0.8, sm: 1.2, md: 1.5 },
                }}
              >
                {otpDigits.map((digit, index) => (
                  <Box
                    key={index}
                    component="input"
                    ref={(el) => {
                      otpRefs.current[index] = el;
                    }}
                    type="text"
                    inputMode="numeric"
                    autoComplete={index === 0 ? "one-time-code" : "off"}
                    maxLength={1}
                    value={digit}
                    onChange={handleOtpChange(index)}
                    onKeyDown={handleOtpKeyDown(index)}
                    onPaste={handleOtpPaste(index)}
                    onFocus={(event) => event.target.select()}
                    sx={{
                      width: { xs: 40, sm: 48, md: 56 },
                      height: { xs: 48, sm: 56, md: 64 },
                      flex: 1,
                      maxWidth: 64,
                      textAlign: "center",
                      fontSize: { xs: "20px", sm: "22px", md: "24px" },
                      fontWeight: 600,
                      borderRadius: "12px",
                      border: "1.5px solid #74a0e1",
                      backgroundColor: "#fff",
                      outline: "none",
                      color: "#333",
                      "&:focus": {
                        borderColor: "#4a86d4",
                        boxShadow: "0 0 0 2px rgba(116, 160, 225, 0.25)",
                      },
                    }}
                  />
                ))}
              </Box>
              <Typography
                sx={{
                  mt: 1.5,
                  textAlign: "center",
                  color: "#7a7a7a",
                  fontSize: { lg: "14px", md: "13px", sm: "12px", xs: "11px" },
                }}
              >
                ใช้รหัส OTP จากระบบยืนยันตัวตน ทอ.
              </Typography>
            </Box>
          </Box>

          <Box sx={{ width: "100%", padding: "10px 30px 10px 30px" }}>
            <Button variant="contained" fullWidth onClick={() => login()}>
              คลิกเพื่อเข้าสู่ระบบ
            </Button>
          </Box>
          <Box sx={{ width: "100%", padding: "10px 30px 10px 30px" }}>
            <ColorButton
              variant="contained"
              fullWidth
              onClick={handleClickOpen}
            >
              เข้าสู่ระบบ สำหรับนายทหารนักเรียนต่างเหล่า และต่างชาติ
            </ColorButton>
          </Box>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle
              id="alert-dialog-title"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Box>
                <img
                  src={Logo}
                  alt="logo"
                  style={{ width: "150px", height: "120px" }}
                />
              </Box>
              <Box>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  sx={{
                    fontSize: {
                      lg: "20px",
                      md: "16px",
                      sm: "14px",
                      xs: "14px",
                    },
                  }}
                >
                  ระบบสารสนเทศเพื่อการวัดและประเมินผลการศึกษา
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  sx={{
                    fontSize: {
                      lg: "14px",
                      md: "12px",
                      sm: "12px",
                      xs: "10px",
                    },
                  }}
                >
                  สำหรับนายทหารนักเรียนต่างเหล่า และต่างชาติ
                </Typography>
              </Box>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Box sx={{ width: "100%", padding: "10px 30px 10px 30px" }}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel htmlFor="outlined">E-mail</InputLabel>
                      <OutlinedInput
                        id="outlined"
                        label="E-mail"
                        onChange={(event) => {
                          setEmails(event.target.value);
                        }}
                      />
                    </FormControl>
                  </Box>

                  <Box sx={{ width: "100%", padding: "10px 30px 10px 30px" }}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel htmlFor="outlined-adornment-password">
                        Password
                      </InputLabel>

                      <OutlinedInput
                        id="outlined-adornment-password"
                        type={valuess.showPassword ? "text" : "password"}
                        // value={valuess.password}
                        onChange={handleChanges("password")}
                        label="Password"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPasswords}
                              onMouseDown={handleMouseDownPasswords}
                              edge="end"
                            >
                              {valuess.showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </Box>
                  <Box sx={{ width: "100%", padding: "10px 30px 10px 30px" }}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel htmlFor="outlined">
                        รหัสประจำตัวข้าราชการ 10 หลัก
                      </InputLabel>
                      <OutlinedInput
                        inputProps={{ maxLength: 10, mixLength: 10 }}
                        // error={perid.length <= 0 && perid.length < 10}
                        id="outlined"
                        label="รหัสประจำตัวข้าราชการ 10 หลัก"
                        onChange={(event) => {
                          setPerid(event.target.value);
                        }}
                      />
                    </FormControl>
                  </Box>
                </Box>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "10px",
                }}
              >
                <Box sx={{ margin: "10px" }}>
                  <Button onClick={() => loginforeign()} variant="contained">
                    เข้าสู่ระบบ
                  </Button>
                </Box>
                <Box sx={{ margin: "10px" }}>
                  <Button
                    onClick={handleClose}
                    variant="outlined"
                    color="error"
                  >
                    ยกเลิก
                  </Button>
                </Box>
              </Box>
            </DialogActions>
          </Dialog>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              flexDirection: {
                lg: "row",
                md: "row",
                sm: "column",
                xs: "column",
              },
              alignItems: "center",
            }}
          >
            {/* <Box sx={{width:'100%',padding:'10px 10px 10px 30px'}}> */}
            <Box
              sx={{
                width: "100%",
                padding: {
                  lg: "10px 10px 10px 30px",
                  md: "10px 10px 10px 30px",
                  sm: "10px 30px 10px 30px",
                  xs: "10px 30px 10px 30px",
                },
              }}
            >
              <Link to="/RegisStu">
                <Button
                  variant="outlined"
                  sx={{ width: "100%", fontSize: "11px" }}
                >
                  สมัครสมาชิกสำหรับ นทน. สำหรับนายทหารนักเรียน ทอ.
                </Button>
              </Link>
            </Box>
            {/* <Box sx={{width:'100%',padding:'10px 30px 10px 10px'}}> */}
            <Box
              sx={{
                width: "100%",
                padding: {
                  lg: "10px 30px 10px 10px",
                  md: "10px 30px 10px 10px",
                  sm: "10px 30px 10px 30px",
                  xs: "10px 30px 10px 30px",
                },
              }}
            >
              <Link to="/RegisTeac">
                <Button
                  variant="outlined"
                  sx={{ width: "100%", fontSize: "12px" }}
                >
                  สมัครสมาชิกสำหรับ เจ้าหน้าที่
                </Button>
              </Link>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box sx={{ fontWeight: "bold", marginTop: "10px" }}>
              <p>ติดต่อสอบถาม</p>
            </Box>
            <Box sx={{ fontWeight: "bold", fontSize: "12px", display: "flex" }}>
              <p>
                <PhoneForwardedIcon sx={{ fontSize: "14px" }} />{" "}
                กรมยุทธศึกษาทหารอากาศ โทร 2-5777
              </p>
            </Box>
            <Box sx={{ fontWeight: "bold", fontSize: "10px" }}>
              <p>Version 1.0.0</p>
            </Box>
            <Box sx={{ fontSize: "10px" }}>
              <p>
                DESIGNED BY STANDARD DIVISION &reg; {new Date().getFullYear()}
              </p>
            </Box>
          </Box>
        </Box>
      </Box>
      {/* </div> */}
      {/* </div> */}
    </React.Fragment>
  );
}
